var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Modal from "@irati/ui/src/Modal/Modal";
import tracking from "@irati-tracking/perks/perks";
import ZipModalContent from "./ZipModalContent";
var ZipModal = /** @class */ (function (_super) {
    __extends(ZipModal, _super);
    function ZipModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { show: false };
        _this.show = function () {
            tracking.viewZipModal();
            _this.setState({ show: true });
        };
        _this.closeModal = function () { return _this.setState({ show: false }); };
        return _this;
    }
    ZipModal.prototype.render = function () {
        return (React.createElement(Modal, { show: this.state.show, onHide: this.closeModal },
            React.createElement(ZipModalContent, null)));
    };
    return ZipModal;
}(PureComponent));
export default ZipModal;
